import api from '../../../App/socket';

export const getWebJobs = () => api.send({
    api: 'db',
    model: 'Web_jobs',
    action: 'Read',
    options: {
        attributes: 'all',
        limit: 10,
        where: {
            job_type: 'priceomatic',
        },
        order: {
            created_date: 'desc',
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic/requests/get_web_jobs_request.js